import { ReactElement, useEffect, useState } from "react";
import { wire } from "react-hot-wire";

import { ApplicationService } from "services/application/Application.service";

function InitAuthorization({
  applicationService,
  children
}: {
  applicationService: ApplicationService;
  children: ReactElement;
}) {
  const [render, setRenderState] = useState(false);

  useEffect(() => {
    (async function init() {
      await applicationService.init();
    })();

    setRenderState(true);
  }, [applicationService]);

  return render ? children : null;
}

export default wire(["applicationService"], InitAuthorization);
